import React from "react";

import { CurrencySign } from "../../utils/helper";

const CardContainer = ({
  data: { title, value, bgColor },
}: {
  data: {
    title: string;
    value: number;
    bgColor: string;
  };
}) => {
  const amount =
    value < 0 ? `- ${CurrencySign}${Math.abs(value).toLocaleString()}` : value;

  return (
    <div
      className={`rounded-[1rem] min-h-[166px] flex flex-col justify-end items-center border border-[#E5E9F2] px-3 pb-8`}
      style={{ background: bgColor }}
    >
      <div className="flex flex-col justify-center gap-3 text-center">
        <h1
          className={`font-[900] text-[1.5rem] ${
            value < 0 ? "text-red-500" : "text-[#0C4654]"
          } `}
        >
          {amount}
        </h1>
        <h1 className="text-[1rem] font-[500] text-[#0C4654]">{title}</h1>
      </div>
    </div>
  );
};

export default CardContainer;
